import React from "react";
import PropTypes from "prop-types";

export const SectionTitle = ({ title, fancy = false }) => {
  return (
    <h2 className={"section-title" + (fancy ? " section-title--fancy" : "")}>
      <span className="section-title-text">{title}</span>
    </h2>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string,
  fancy: PropTypes.bool,
};

SectionTitle.defaultProps = {
  title: null,
  fancy: false,
};
